import serviceAxios from "../index";


//获取协议
export function agreementApi(params) {
	return serviceAxios({
		url: '/api/base/agreement',
		method: 'get',
		params
	})
}
// 查看ip省份
export function getContent() {
  return serviceAxios({
    url: '/api/user/getContent',
    method: 'get',
  })
}

//登录
export const passwordloginApi = (data) => {
	return serviceAxios({
		url: "/api/user/phoneAndPasswordLogin",
		method: "post",
		data,
	});
};


//验证码登录
export const phoneAndCodeLoginApi = (data) => {
	return serviceAxios({
		url: "/api/user/phoneAndCodeLogin",
		method: "post",
		data,
	});
};
//获取登录验证码
export const captcha = (params) => {
	return serviceAxios({
		url: "/api/captcha/image",
		method: "get",
		params,
	});
};

//校验验证码
export const captchaVerify = (data) => {
	return serviceAxios({
		url: "/api/captcha/verify",
		method: "post",
		data,
	});
};

//发送短信验证码
export function sendCodeApi(params) {
	return serviceAxios({
		url: "/api/user/sendCode",
		method: "get",
		params,
	});
}



//注册
export function registerApi(data) {
	return serviceAxios({
		url: "/api/user/register",
		method: "post",
		data,
	});
}

//获取电工类型
export function electicianTypeApi() {
	return serviceAxios({
		url: "/api/user/electicianType",
		method: "get"
	});
}

//获取系统基本信息
export function webInfoApi() {
	return serviceAxios({
		url: '/api/base/baseConfigured',
		method: 'get'
	})
}

// 访问量
export function queryPcTotal() {
	return serviceAxios({
		url: '/api/tPageViews/queryPcTotal',
		method: 'get'
	})
}


// 个人资料保存
export function saveUserInfo(data) {
	return serviceAxios({
		url: '/api/master/update',
		method: 'post',
		data
	})
}

// 新增地址
export function addAddress(data) {
	return serviceAxios({
		url: '/api/master/addAddress',
		method: 'post',
		data
	})
}


// 修改地址
export function updateAddress(data) {
	return serviceAxios({
		url: '/api/master/updateAddress',
		method: 'post',
		data
	})
}


// 删除地址
export function delAdderss(params) {
	return serviceAxios({
		url: '/api/master/delAdderss',
		method: 'get',
		params
	})
}
//联系客服
export function contactListApi(params) {
	console.log(params);
	return serviceAxios({
		url: '/api/contract/sendList',
		method: 'get',
		params
	})
}

//新增客服
export function contactAddApi(data) {
	return serviceAxios({
		url: '/api/contract/add',
		method: 'post',
		data
	})
}

//留言列表
export function contactIndexListApi(params) {
	return serviceAxios({
		url: '/api/contract/list',
		method: 'get',
		params
	})
}

//厂商和电工聊天列表
export function contactFactoryAndElecListApi(params) {
	return serviceAxios({
		url: '/api/contract/factoryAndElecList',
		method: 'get',
		params
	})
}

//客戶评分
export function userScoreApi(params) {
	return serviceAxios({
		url: '/api/score/userScore',
		method: 'get',
		params
	})
}

//token过期检验
export function tokenHealthApi() {
	return serviceAxios({
		url: '/api/base/health',
		method: 'get'
	})
}

// 校验银行卡
export function checkBankCard(params) {
	return serviceAxios({
		url: '/api/bank/checkBankCard',
		method: 'post',
		data: params
	})
}

// 首页 待办消息 总数
export function getCountTaskMessage() {
	return serviceAxios({
		url: '/api/system/need/getCountTaskMessage',
		method: 'get'
	})
}
// 首页 待办任务
export function getTaskMessage() {
	return serviceAxios({
		url: '/api/system/need/getTaskMessage',
		method: 'get'
	})
}
// 首页 待办任务 已读
export function updateShareNewsIsLook(params) {
	return serviceAxios({
		url: '/api/system/need/updateShareNewsIsLook/'+params,
		method: 'get'
	})
}


export function getUserWeidu(params) {
	return serviceAxios({
		url: '/api/contract/weidu',
		method: 'get',
		params
	})
}

export function readtypechange2(params) {
	return serviceAxios({
		url: '/api/contract/updateweidu',
		method: 'post',
		data: params
	})
}

